
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectSlug]/posts",
      function () {
        return require("private-next-pages/[projectSlug]/posts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[projectSlug]/posts"])
      });
    }
  